<template>
    <div class="not-found container">
        <div class="row">
            <div class="col-12 text-center">
                <img class="img-fluid mt-1 mb-4" src="@/assets/img/404.png" />
                <div class="col-sm-12 col-md-6 offset-md-3 text-left">
                    <p>Oups, page non trouvée.</p>
                    <p>Veuillez vérifier le URL ou essayer de nouveau.</p>
                </div>
                <b-btn :to="{ name: 'home' }" class="text-light mt-5" pill variant="primary">
                    Retour à la page d'accueil
                </b-btn>
            </div>
        </div>
    </div>
</template>
<script>
/**
 * @file       Not Found component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export component.
 * 
 * @type  {Object}
 */
export default {
  name: "Not Found"
};
</script>
